var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 52,
    viewBox: "0 0 80 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.375 21.6429C65.375 21.4286 65.4107 21.2143 65.4107 21C65.4107 9.39286 56.1607 0 44.75 0C36.5179 0 29.4464 4.89286 26.125 11.9643C24.6786 11.2321 23.0536 10.8036 21.3393 10.8036C16.0714 10.8036 11.6786 14.7143 10.8393 19.8214C4.51786 22 0 28.0536 0 35.1786C0 44.1429 7.16071 51.4286 15.9821 51.4286H34.2857V37.1429H25.6786L40 22.1964L54.3214 37.125H45.7143V51.4107H65.4107C73.4821 51.4107 80 44.7143 80 36.5179C80 28.3214 73.4464 21.6607 65.375 21.6429Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.34eac9e34d3a4f3f65d23f09ec2ad917.svg";
export { ForwardRef as ReactComponent };